import { Routes, Route } from 'react-router-dom';
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import AboutUs from "./Pages/AboutUs";
import Blogs from "./Pages/Blogs";
import Gallery from "./Pages/Gallery";
import Faq from "./Pages/Faq";
import Contact from "./Pages/Contact";
import BlogInner from "./Pages/BlogInner";
import CorporateEvemts from "./Pages/CorporateEvents";
import Weddings from "./Pages/Weddings";
import NotFound from "./Pages/NotFound"; // Add a NotFound page
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';

function App() {
  return (
    
      
        <div className="App">
            <header className='header'>
              <Header />
            </header>
            <div className='content'>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blogs/blog-inner" element={<BlogInner />} />
                {/* Catch-all route for undefined pages */}
                <Route path="*" element={<NotFound />} />
                <Route path="/services/weddings" element={<Weddings />} />
                <Route path="/services/corporate-events" element={<CorporateEvemts />} />
              </Routes>
            </div>
            <footer className='footer'>
              <Footer />
            </footer>
        </div>    
      
  );
}

export default App;
